import React from 'react'
import * as Form from '../../../Form'
import { Spinner } from '../../../Spinner'
import { Field, FormFacade, FieldInterceptChange, InterceptChangeEvent } from '../../types'
import { StyledTextarea } from './styled'

interface Props {
  id?: string
  autoFocus?: boolean
  field?: Field<HTMLTextAreaElement, string>
  form?: FormFacade
  interceptChange?: FieldInterceptChange<string>
  label?: string
  maxLength?: number
  placeholder?: string
  hasAutoPlaceholder?: boolean
  isLoading?: boolean
  isDisabled?: boolean
  isRequired?: boolean
  isReadOnly?: boolean
}

export const TextArea = ({
  id,
  autoFocus,
  field,
  form,
  interceptChange,
  label,
  maxLength,
  placeholder,
  hasAutoPlaceholder,
  isRequired,
  isLoading,
  isDisabled,
  isReadOnly
}: Props) => {
  const { name, value, onChange, onBlur } = field ?? {}
  const { errors, touched } = form ?? {}
  const hasError = name && errors?.[name] && touched?.[name]
  const inputPlaceholder = placeholder ?? (hasAutoPlaceholder ? label : undefined)
  const _id = id ?? name

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (!name || !form) {
      return
    }

    const changeEvent: InterceptChangeEvent<string> = {
      value: event.target.value,
      name,
      form
    }

    const shouldIntercept = interceptChange?.(changeEvent)

    if (!shouldIntercept) {
      onChange?.(event)
    }
  }

  return (
    <Form.Field
      hasError={hasError}
      className={`form-field form-field--textarea ${hasError ? 'form-has-error' : ''}`}
    >
      {label && (
        <Form.Label htmlFor={_id}>
          <span>{label}</span>
          {isRequired && <em>*</em>}
        </Form.Label>
      )}

      <StyledTextarea
        id={_id}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={isDisabled ?? isLoading}
        maxLength={maxLength}
        autoFocus={autoFocus}
        placeholder={inputPlaceholder}
        readOnly={isReadOnly}
      />

      {isLoading && (
        <Spinner size={20} />
      )}

      {hasError && name && (
        <Form.Error>
          {errors?.[name]}
        </Form.Error>
      )}
    </Form.Field>
  )
}
